define(
  ({
    copy: '複製',
    paste: '貼上',
    copyToAll: '複製至所有',
    add_to_cart: '加至購物車',
    addToCart: '加至購物車',
    remove: '移除',
    added: '已加入',
    dropped: '已捨棄',
    units: '單位',
    total: '總計',
    atsWarning: '在%{availableOn}前不會有此數量。',
    inventory_warehouse: '庫存倉',
    notInCatalog: '未能將項目加至購物車',
    notInCatalogExplanation: '對不起，尚未可將產品在目錄之間加入。',
    digital_market_notInCatalogExplanation: '購物車一次只能放進單一品牌的商品',
    removeFromCartSuggestion: '你想<link>清空購物車</link>嗎？',
    digital_market_removeFromCartSuggestion: '你想<link>清空購物車</link>以加入此商品嗎？',
    emptyCart: '清空購物車',
    empty: '清空',
    emptyConfirmation: '你確定希望清空購物車嗎？',
    available_on: '將於以下日期到貨',
    personalization: '個人化',
    personalize: '個人化',
    placement: '配置',
    content: '內容',
    color: '色彩',
    product_specification: '商品規格',
    type: '種類',
    logo: '標記',
    text: '文字',
    text_and_logo: '文字標記',
    other: '其他',
    value_might_be_stale: '由於購物車變動，此數值或已過期。儲存訂單以重新計算。',
    more_details: '更多細節',
    availability: '存貨量',
    no_scheduled_availability: '無到貨排期',
    not_available_until: '<date />前無存貨',
    available_as_of: '<date />起有存貨',
    units_bundled_singular_label: '%{units} 同捆單位',
    units_bundled_label: '%{units} 同捆單位',
    add_bundle_to_cart: '將同捆包加至購物車',
    bundles: '同捆包',
    bundled: '同捆',
    product: '產品',
    sizes_and_quantities: '尺寸／數量',
    units_singular_label: '%{units} 單位',
    units_label: '%{units} 單位',
    current_availability: '目前存貨量',
    future_availability: '未來存貨量',
    size: '尺寸',
    sku: 'SKU',
    availability_date: '存貨量日期',
    quantity: '數量',
    availability_subject_to_change: '存貨量會因應實際情況而調整',
    yes: '是',
    no: '否',
    copy_to_all_confirmation_message: '確定要將此尺寸範圍複製到以下所有款式嗎？',
  }),
);
